/**
 * Return the YYYY-MM-DD portion of a Date (local time, not UTC).
 * Avoids the common `toISOString().split('T')[0]` pattern which
 * silently shifts dates near midnight due to UTC conversion.
 */
export function toDateString(date: Date = new Date()): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * Format an ISO date string or Date into a human-readable medium date
 * (e.g. "Jan 15, 2025") using the user's locale.
 */
export function formatDate(isoOrDate: string | Date): string {
  const date = typeof isoOrDate === 'string' ? new Date(isoOrDate) : isoOrDate;
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' }).format(date);
}

/**
 * Format a Date into a 24-hour time string (e.g. "14:30").
 */
export function formatTime(date: Date): string {
  return new Intl.DateTimeFormat(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);
}
